export default __webpack_public_path__ + "static/media/BESS-cabinate.0c3c0b2a.47796e63.png";